<template>
	<div class="message">
		<template v-if="row.batch">
			<div class="content" v-for="message in row.batch">
				<h5 v-if="message.title">{{ message.title }}</h5>
				<p v-if="body">{{ message.text }}</p>
				<p v-bind:class="['ref', message.ref_type]" v-if="message.ref_type">
					<i class="el-icon-link"></i>
					{{ getContentKey(message.ref_type, message.ref_id, 'title') }}
					<span>
						{{ message.ref_type }}
					</span>
				</p>
			</div>
		</template>
		<template v-else>
			<h5 v-if="row.title">{{ row.title }}</h5>
			<p v-if="body">{{ row.text }}</p>
			<p v-bind:class="['ref', row.ref_type]" v-if="row.ref_type">
				<i class="el-icon-link"></i>
				{{ getContentKey(row.ref_type, row.ref_id, 'title') }}
				<span>
					{{ row.ref_type }}
				</span>
			</p>
		</template>
	</div>
</template>

<script>
import Column from '.'

export default {
	name: 'message-preview-column',
	extends: Column,

	props: {
		body: {
			type: Boolean,
			default: true
		}
	}
}
</script>

<style lang="scss" scoped>
.message {
	h5 {
		margin: 0;
		font-size: 14px;
		word-break: break-word;
	}
	p {
		font-size: 14px;
		word-break: break-word;
	}
	.ref {
		display: inline-block;
		background: #f0f0f0;
		margin: 5px 0 10px 0;
		border-radius: 15px;
		padding: 5px 15px 5px 10px;
		font-weight: 500;
		font-size: 14px;

		span {
			font-weight: 400;
			opacity: 0.5;
			padding-left: 5px;
		}
	}
	.ref.questionnaire {
		background: lighten(#913b9c, 50%);
	}
	.ref.article {
		background: lighten(#833e93, 50%);
	}
	.ref.appointment {
		background: lighten(#355170, 50%);
	}
}
</style>
